'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'chess-queen-piece';
var width = 320;
var height = 512;
var aliases = ["chess-queen-alt"];
var unicode = 'f446';
var svgPathData = 'M187-5c0 14.9-12.1 27-27 27s-27-12.1-27-27 12.1-27 27-27 27 12.1 27 27zm61 205c13.3 0 24 10.7 24 24s-10.7 24-24 24l-5.6 0 13.6 136 56.2 70.3c5 6.3 7.8 14.1 7.8 22.2 0 19.6-15.9 35.5-35.5 35.5L35.5 512c-19.6 0-35.5-15.9-35.5-35.5 0-8.1 2.7-15.9 7.8-22.2L64 384 77.6 248 72 248c-13.3 0-24-10.7-24-24s10.7-24 24-24l.7 0-69.1-114C1.3 82.1 0 77.6 0 73 0 59.2 11.2 48 25 48l.9 0c4 0 8 .9 11.6 2.7L64 64 97.8 37c4-3.2 9.1-5 14.2-5s10.2 1.8 14.2 5L160 64 193.8 37c4-3.2 9.1-5 14.2-5s10.2 1.8 14.2 5L256 64 282.5 50.7c3.6-1.8 7.6-2.7 11.6-2.7l.9 0c13.8 0 25 11.2 25 25 0 4.6-1.3 9.1-3.6 13l-69.1 114 .7 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessQueenPiece = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;